var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{on:{"addEvent":function($event){return _vm.$router.push({name: 'units.add'})}}},[_vm._v(_vm._s(_vm.$t('units.units')))]),_c('main-table',{attrs:{"fields":_vm.fields,"baseURL":_vm.SFZ_API_LINK,"list_url":_vm.unitsLink,"limitStatus":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }